import { RequestCompanionListPayload } from '@core/dto';
import { ReservationAdapter } from '@core/adapters';
export class RequestCompanionListUseCase {
  constructor(private readonly reservationAdapter: ReservationAdapter) {
    this.reservationAdapter = reservationAdapter;
  }
  public async execute(payload: {
    reservationId: number;
    cmpnList: RequestCompanionListPayload[];
  }): Promise<void> {
    return await this.reservationAdapter.requestCompanionList(payload);
  }
}
